module.exports = __webpack_public_path__ + "img/error.30d7caa4.svg";